import React from "react"
import { Flex } from "@infotech/uikit-grid"
import styles from "../styles.css"

const Row = ({ title, value }) => (
  <Flex justify="space-between">
    <span className={styles[`secondary-attention-font`]}>{title}</span>
    <span className={styles[`main-attention-font`]}>{value}</span>
  </Flex>
)

export default Row
